import React, { Suspense } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Button, LinearProgress } from "@mui/material";

class RouteErrorBoundary extends React.Component<
  React.PropsWithChildren,
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  render(): React.ReactNode {
    if (this.state.failed) {
      return (
        <div role="alert">
          <p>Unable to load this page. Please reload and try again.</p>
          <Button
            variant="contained"
            onClick={(): void => window.location.reload()}
          >
            Reload
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}

const Home = React.lazy(
  () =>
    import(
      /* webpackChunkName: "agents-home" */ "modules/home/pages/home/home.component"
    )
);
const PropertyDetailsPage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "agents-property-details" */ "modules/property/pages/property-details/property-details.component"
    )
);

function AppRoutes(): JSX.Element {
  const { pathname } = useLocation();
  return (
    <RouteErrorBoundary key={pathname}>
      <Suspense fallback={<LinearProgress />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/property-details" element={<PropertyDetailsPage />} />
          <Route path="*" element={<p>not found</p>} />
        </Routes>
      </Suspense>
    </RouteErrorBoundary>
  );
}

export default AppRoutes;
